export const BOHDISYS_API_URL = 'https://api.bodhisys.io';
export const BOHDISYS_BASE_URL = 'https://api.bodhisys.io';
export const STRIPE_PUBLIC_KEY = 'pk_live_xbuOrv8Cb4oXWPns8yJvOVnL00VroSgXDR';
export const STRIPE_PUBLIC_KEY_STAND = 'pk_live_xbuOrv8Cb4oXWPns8yJvOVnL00VroSgXDR';
export const GOOGLE_MAP_KEY = 'AIzaSyACTjifW_x-VPS_zmLGEXfGxxphP6jNrzs';
export const GOOGLE_MAP_Id = '28084817044252a2';
export const LLC_MASTER_KEY = 'bodhisys-llc-super-admin-2025';